import React, { useEffect, useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

function LoyaltyQuillEditor({ value = '', onChange, placeholder, label, name, error = false, errorMessage }) {
  const [content, setContent] = useState(value || '');
  // const [wordCount, setWordCount] = useState(0);

  useEffect(() => {
    setContent(value || '');
  }, [value]);

  const handleChange = (nextContent) => {
    setContent(nextContent);
    onChange?.(nextContent);

    const textOnly = nextContent.replace(/<[^>]+>/g, '');
    const words = textOnly.trim().split(/\s+/).filter(Boolean);
    const lines = textOnly.split(/\n/).filter((line) => line.trim().length > 0);
    // setWordCount(words.length + lines.length);
  };

  const modules = {
    toolbar: [
      [{ header: '1' }, { header: '2' }, { font: [] }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['bold', 'italic', 'underline', 'strike'],
    ],
  };

  return (
    <div>
      {label ? (
        <label htmlFor={name} className={`mb-2 block text-sm font-semibold ${error ? 'text-red-600' : 'text-gray-900'}`}>
          {label}
        </label>
      ) : null}
      <div className={`quill-editor block w-full rounded-md border-0 py-2 px-4 text-gray-900 shadow-sm ring-1 ring-inset ${error ? 'ring-red-300' : 'ring-gray-300'} placeholder:text-gray-400 focus:ring-1 focus:ring-inset outline-none ${error ? 'focus:ring-red-400' : 'focus:ring-gray-400'} sm:text-sm/6`}>
        <ReactQuill
          id={name}
          value={content}
          onChange={handleChange}
          modules={modules}
          theme="snow"
          placeholder={placeholder}
        />
        {/* <p className="p-2 text-right text-xs text-gray-600">Word Count: {wordCount}</p> */}
      </div>
      {error && errorMessage ? <p className="mt-1 text-xs text-red-600">{errorMessage}</p> : null}
      <style>{`
        .ql-toolbar.ql-snow, .ql-container.ql-snow { border: none !important; }
      `}</style>
    </div>
  );
}

export default LoyaltyQuillEditor;
